import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/contexts'
import { ProfileType } from '@/enum/profile-type'

import { BottomBar } from './bottombar/bottombar'
import { BackOfficeSideBar } from './sidebar/sidebar'

export function LayoutBackOffice() {
  const { userProfiles, signed } = useAuth()

  if (!signed) {
    return <Navigate to="/login" />
  }

  const isNotAdminOrSuperAdmin =
    !userProfiles?.includes(ProfileType.Admin) &&
    !userProfiles?.includes(ProfileType.SuperAdmin)

  if (isNotAdminOrSuperAdmin) {
    return <Navigate to="/not-allowed" replace />
  }

  return (
    <div className="relative flex flex-1 flex-col overflow-hidden lg:flex-row">
      <BackOfficeSideBar className="hidden lg:block" />

      <div className="flex-1 bg-monochromatic-200 lg:*:h-[calc(100vh-6rem)] 2xl:*:h-[calc(100vh-7rem)]">
        <div className="h-full overflow-y-auto">
          <Outlet />
        </div>
      </div>
      <BottomBar />
    </div>
  )
}
